<!-- @format -->
@if (showCompare()) {
	<div [class]="wrapperClasses() + ' hmf-display-flex hmf-flex-column'">
		<div class="hmf-header-bold-l hmf-p-s">Compare Similar Items</div>
		<div
			class="hmf-overflow-hidden hmf-mt-xxs"
			[style.max-height.px]="collapseContainerHeight()"
			[style.transition]="'max-height ease-in-out'"
			[style.transition-duration.ms]="collapsed() ? 250 : 300">
			<compare-components-compare-grid
				#compareGrid
				[compareBarProducts]="compareBarProducts()"
				[compareProductDetails]="compareProductDetails()"
				[compareGridLoading]="false"
				[compareGridApiFailed]="false"
				location="PDP"
				class="hmf-display-block">
			</compare-components-compare-grid>
		</div>
		<div class="hmf-display-flex hmf-justify-content-center hmf-mt-s">
			<button
				hmf-button
				variant="secondary"
				(click)="toggleSectionCollapsed()"
				class="collapse-toggle">
				{{ collapsed() ? 'View More' : 'View Less' }}
				<!-- Replace this once hmf-button supports right icon -->
				<homefield-icon
					width="16px"
					height="16px"
					[name]="collapsed() ? 'chevron-down' : 'chevron-up'"></homefield-icon>
			</button>
		</div>
	</div>
}
